import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import { ServicesIndex, ServiceDetail } from './pages/ServicesPage';
import LuminarcPage from './pages/LuminarcPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import { Login, Dashboard } from './pages/PortalPage';
import DPDPPage from './pages/DPDPPage';
import './App.css';

// Layout component that includes Header and Footer
const Layout = ({ children, showFooter = true }) => {
  return (
    <>
      <Header />
      {children}
      {showFooter && <Footer />}
      <CookieConsent />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App min-h-screen flex flex-col">
          <Routes>
            {/* Public Pages */}
            <Route
              path="/"
              element={
                <Layout>
                  <HomePage />
                </Layout>
              }
            />
            <Route
              path="/about"
              element={
                <Layout>
                  <AboutPage />
                </Layout>
              }
            />
            <Route
              path="/services"
              element={
                <Layout>
                  <ServicesIndex />
                </Layout>
              }
            />
            <Route
              path="/services/dpdp-compliance"
              element={
                <Layout>
                  <DPDPPage />
                </Layout>
              }
            />
            <Route
              path="/services/:slug"
              element={
                <Layout>
                  <ServiceDetail />
                </Layout>
              }
            />
            <Route
              path="/testimonials"
              element={
                <Layout>
                  <TestimonialsPage />
                </Layout>
              }
            />
            <Route
              path="/contact"
              element={
                <Layout>
                  <ContactPage />
                </Layout>
              }
            />
            <Route
              path="/luminarc"
              element={
                <Layout>
                  <LuminarcPage />
                </Layout>
              }
            />
            <Route
              path="/privacy"
              element={
                <Layout>
                  <PrivacyPolicyPage />
                </Layout>
              }
            />
            <Route
              path="/terms"
              element={
                <Layout>
                  <TermsOfServicePage />
                </Layout>
              }
            />

            {/* Client Portal */}
            <Route
              path="/portal"
              element={
                <Layout showFooter={false}>
                  <Login />
                </Layout>
              }
            />
            <Route
              path="/portal/dashboard"
              element={
                <Layout showFooter={false}>
                  <Dashboard />
                </Layout>
              }
            />

            {/* 404 Page */}
            <Route
              path="*"
              element={
                <Layout>
                  <main className="pt-20 min-h-screen flex items-center justify-center bg-brand-bg-light">
                    <div className="text-center">
                      <h1 className="font-heading text-6xl font-bold text-brand-charcoal mb-4">404</h1>
                      <p className="text-brand-muted mb-8">Page not found</p>
                      <a
                        href="/"
                        className="inline-block bg-brand-gold text-brand-charcoal font-semibold px-8 py-3 hover:bg-brand-gold-lite transition-colors"
                      >
                        Go Home
                      </a>
                    </div>
                  </main>
                </Layout>
              }
            />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
